<div class="site-page-header-ghost-wrapper">
  <nz-page-header [nzGhost]="false">
    <nz-page-header-title class="ml4"
      >Help & Support Requests</nz-page-header-title
    >
  </nz-page-header>
</div>

<!-- Filters Row -->
<div nz-row [nzGutter]="16" class="mt4">
  <!-- Search -->
  <div nz-col nzLg="6" nzMd="8" nzSm="24" nzXs="24" class="mb5">
    <nz-form-label nzFor="search">Search</nz-form-label>
    <nz-input-group [nzSuffix]="suffixIconSearch">
      <input
        type="text"
        nz-input
        placeholder="Search by name, email"
        ngModel
        (ngModelChange)="searchHelpSupport($event)"
      />
    </nz-input-group>
    <ng-template #suffixIconSearch>
      <i nz-icon nzType="search"></i>
    </ng-template>
  </div>

  <!-- Query Type Filter -->
  <div nz-col nzLg="5" nzMd="8" nzSm="24" nzXs="24" class="mb5">
    <nz-form-label>Query Type</nz-form-label>
    <nz-select
      nzAllowClear
      nzPlaceHolder="Filter by Query Type"
      [(ngModel)]="selectedQueryType"
      (ngModelChange)="onQueryTypeChange($event)"
      style="width: 100%"
    >
      <nz-option
        nzValue="subscription_plan"
        nzLabel="Subscription Plan"
      ></nz-option>
      <nz-option nzValue="payment_issue" nzLabel="Payment Issue"></nz-option>
      <nz-option nzValue="app_bug" nzLabel="App Bug"></nz-option>
      <nz-option nzValue="other" nzLabel="Other"></nz-option>
    </nz-select>
  </div>

  <!-- User Filter -->
  <div nz-col nzLg="5" nzMd="8" nzSm="24" nzXs="24" class="mb5">
    <nz-form-label>User</nz-form-label>
    <nz-select
      nzAllowClear
      nzShowSearch
      nzPlaceHolder="Filter by User"
      [(ngModel)]="selectedUser"
      (ngModelChange)="onUserChange($event)"
      style="width: 100%"
    >
      <nz-option
        *ngFor="let user of userList"
        [nzValue]="user._id"
        [nzLabel]="user.name"
      ></nz-option>
    </nz-select>
  </div>

  <!-- Date Range Filter -->
  <div nz-col nzLg="8" nzMd="12" nzSm="24" nzXs="24" class="mb5">
    <nz-form-label>Date Range</nz-form-label>
    <nz-range-picker
      [(ngModel)]="dateRange"
      (ngModelChange)="onDateRangeChange($event)"
      style="width: 100%"
    ></nz-range-picker>
  </div>
</div>

<!-- Help Support Table -->
<nz-table
  #helpSupportTable
  [nzData]="helpSupportList"
  [nzLoading]="loading"
  [nzTotal]="totalDataCount"
  [(nzPageSize)]="pageSize"
  [nzPageIndex]="pageIndex"
  [nzFrontPagination]="false"
  (nzQueryParams)="onQueryParamsChange($event)"
  nzShowSizeChanger
  [nzScroll]="{ x: '1200px' }"
>
  <thead>
    <tr>
      <th nzColumnKey="fullName" [nzSortFn]="true">Full Name</th>
      <th>Email</th>
      <th nzWidth="220px">Account Details</th>
      <th>Query Type</th>
      <th nzWidth="250px">Description</th>
      <th nzWidth="120px">Status</th>
      <th nzWidth="150px">Created At</th>
      <th class="text-right" nzWidth="150px">Action</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let data of helpSupportTable.data">
      <td>{{ data.fullName }}</td>
      <td>{{ data.email }}</td>
      <td>
        <div *ngIf="data.user" class="account-details">
          <div class="mb2">
            <i nz-icon nzType="idcard" nzTheme="outline" class="mr1"></i>
            <strong>{{ data.user.name }}</strong>
          </div>
          <div class="mb2">
            <i nz-icon nzType="mail" nzTheme="outline" class="mr1"></i>
            <span>{{ data.user.email }}</span>
          </div>
          <div>
            <i nz-icon nzType="phone" nzTheme="outline" class="mr1"></i>
            <span>{{ data.user.mobile }}</span>
          </div>
        </div>
        <span *ngIf="!data.user">—</span>
      </td>
      <td>
        <nz-tag [nzColor]="getQueryTypeColor(data.queryType)">
          {{ getQueryTypeLabel(data.queryType) }}
        </nz-tag>
      </td>
      <td>
        <span nz-tooltip [nzTooltipTitle]="data.description">
          {{ data.description | slice: 0 : 40
          }}{{ data.description.length > 40 ? "..." : "" }}
        </span>
      </td>
      <td>
        <nz-tag [nzColor]="getStatusColor(data.status)">
          {{ getStatusLabel(data.status) }}
        </nz-tag>
      </td>
      <td>{{ data.createdAt | date: "mediumDate" }}</td>
      <td class="action-buttons">
        <!-- Mark In Progress -->
        <a
          nz-button
          nz-tooltip
          nzTooltipTitle="Mark In Progress"
          nzTooltipPlacement="topCenter"
          *ngIf="data.status === 'open'"
          (click)="updateStatus(data._id, 'in_progress')"
        >
          <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
        </a>
        <!-- Mark Resolved -->
        <a
          nz-button
          nz-popconfirm
          nzPopconfirmTitle="Mark this request as resolved?"
          (nzOnConfirm)="updateStatus(data._id, 'resolved')"
          nzTooltipTitle="Mark Resolved"
          nzTooltipPlacement="topCenter"
          nz-tooltip
          *ngIf="data.status !== 'resolved'"
        >
          <i nz-icon nzType="check-circle" nzTheme="outline"></i>
        </a>
        <!-- Delete -->
        <!-- <a
          class="action-button delete"
          nz-button
          nz-popconfirm
          nzPopconfirmTitle="Are you sure you want to delete this request?"
          (nzOnConfirm)="deleteRequest(data._id)"
          nzTooltipTitle="Delete"
          nzTooltipPlacement="topCenter"
          nz-tooltip
        >
          <i nz-icon nzType="delete" nzTheme="outline"></i>
        </a> -->
      </td>
    </tr>
  </tbody>
</nz-table>
